import script from "./ConclictModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConclictModal.vue?vue&type=script&setup=true&lang=js"

import "./ConclictModal.vue?vue&type=style&index=0&id=67b38fa8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67b38fa8"]])

export default __exports__